import type { LenderIdentity } from '../types/reserveSplitTypes';

export const SPLIT_FRACTION_UPPER_BOUND = 1;

const SPLIT_PERCENT_DECIMALS = 2;

// Rounded because the scaling is binary-float multiplication: a saved 0.56 becomes
// 56.00000000000001, which would both render in the input and travel to Payment Services.
export const toSplitPercent = (reservePaid: number | undefined): number | undefined => {
    if (reservePaid == null || !Number.isFinite(reservePaid)) return undefined;
    if (reservePaid === 0) return 0;

    const asPercent = Math.abs(reservePaid) <= SPLIT_FRACTION_UPPER_BOUND ? reservePaid * 100 : reservePaid;
    return Number(asPercent.toFixed(SPLIT_PERCENT_DECIMALS));
};

const hasIdentity = (lender: LenderIdentity): boolean => Boolean(lender?.id || lender?.name);

export const isDifferentLender = (prevLender: LenderIdentity, newLender: LenderIdentity): boolean => {
    if (!hasIdentity(prevLender)) return false;
    if (prevLender?.id && newLender?.id) return prevLender.id !== newLender.id;
    return prevLender?.name !== newLender?.name;
};
